import React, { useContext } from "react";
import { GlobalDataContext } from "../../context/context";
import { ButtonContent } from "../global/boton/ButtonContent";

function HeroSection() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <>
      <div className="pic-wrapper">
        <figure
          className="pic-1"
          style={{ background: `url("${rpdata?.gallery?.[5]}")` }}
        ></figure>
        <figure
          className="pic-2"
          style={{ background: `url("${rpdata?.gallery?.[4]}")` }}
        ></figure>
        <figure
          className="pic-3"
          style={{ background: `url("${rpdata?.gallery?.[1]}")` }}
        ></figure>
        <figure
          className="pic-4"
          style={{ background: `url("${rpdata?.gallery?.[2]}")` }}
        ></figure>
        <div className="z-10 relative w-4/5 mx-auto h-[120vh]">
          <div className="w-full h-full md:pt-[150px] pt-[250px] pb-[20px] md:pb-[50px] flex flex-col justify-end items-center">
            <h1 className="text-white text-center">
              {rpdata?.dbSlogan?.[0].slogan}
            </h1>
            <p className="text-white text-center">{rpdata?.dbValues?.[1].description}</p>
            <img src="https://firebasestorage.googleapis.com/v0/b/azteca-a-j-landscape-inc.appspot.com/o/21years.png?alt=media&token=657bf1e1-8d9e-41d8-b661-cb15a2ab3cea" alt="years of experience" className="w-[350px] h-[350px] object-contain px-auto" />
            <div className="flex justify-center md:block">
              <ButtonContent />
            </div>
          </div>
          <div className="w-1/2"></div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
